import template from './tableExport.html';
import controller from './tableExport.controller';

let TableExportComponent = {
  restrict: 'E',
  bindings: {
    tableName: '@',
    fileName: '@'
  },
  template,
  controller
};

export default TableExportComponent;



// WEBPACK FOOTER //
// ./client/common/tableExport/tableExport.component.js